import { AnyAction } from 'redux'

import config from '@/config'
import { SignupState } from '@/types'
import {
  SET_ACTIVE_STEP,
  SET_PAGE_CONTENT,
  SET_SIGNUP_ROUTES,
  SET_NEXT_ACTION,
  SET_AB_TEST_TRACKED,
} from './constants'

const { BABYLON_ENVIRONMENT, VERSION } = config

const initialState: Partial<SignupState> = {
  environment: BABYLON_ENVIRONMENT,
  version: VERSION,
}

export default (state = initialState, { type, payload }: AnyAction) => {
  switch (type) {
    case SET_ACTIVE_STEP:
    case SET_PAGE_CONTENT:
    case SET_SIGNUP_ROUTES:
    case SET_NEXT_ACTION:
      return {
        ...state,
        ...payload,
      }
    case SET_AB_TEST_TRACKED:
      return {
        ...state,
        abTestTracked: payload,
      }
    default:
      return state
  }
}
